import TextInput from "../Inputs/TextInput";
import DateInput from "../Inputs/DateInput";
import NumberInput from "../Inputs/NumberInput";
import BooleanInput from "../Inputs/BooleanInput";
import ListTableInput from "../Inputs/ListFieldInput";

export const fieldMapper = {
   "primitives.UUID": TextInput,
   "primitives.String": TextInput,
   "primitives.LocalDate": DateInput,
   "primitives.BigDecimal": NumberInput,
   "primitives.Integer": NumberInput,
   "primitives.Boolean": BooleanInput,
   "primitives.ListTable": ListTableInput,
};
